(function(){
    'use strict'; 
    angular.module('Directives').directive('bbaUnitInput', bbaUnitInput); 
    bbaUnitInput.$inject = ['$filter']; 

    function bbaUnitInput($filter){
        return {
            restrict    : 'E', 
            templateUrl : '/templates/directives/form-components/bba-unit-input.html',
            require     : ['^form', 'ngModel'],
            scope: {
                ngModel    : '=', 
                addOnLabel : '=', 
                label      : '=', 
                id         : '=?',
                hideLabel  : '=?',
                valueType  : '=?',
                orientation: '=?',
                ngRequired : '=?', 
                ngDisabled : '=?',
                onChange   : '=?'
            },
            link        : bbaUnitInputLink
        }

        function bbaUnitInputLink($scope, $attrs, $elems, ngModels) {
            $scope.orientationVertical   = 'vertical'; 
            $scope.orientationHorizontal = 'horizontal';
            $scope.monitaryValuetype     = 'monitary';
            $scope.labelText    = 'labels.formComponents.' + ($scope.label || '').toUpperCase();

            $scope.formatCurrency = formatCurrency;
            
            init();

            function init(){
                formatCurrency();
                initializeWatchers();
            }

            function initializeWatchers () {
                $scope.$watch('ngModel', (data) => {
                    $scope.hasError = ngModels[1].$invalid;
                    if(!$scope.hasError) {
                        $scope.onChange;
                    }
                });
            }

            function formatCurrency(){
                if($scope.valueType === $scope.monitaryValuetype && !ngModels[1].$invalid) {
                    const originalValue = angular.isDefined($scope.ngModel) ? $scope.ngModel : 0;
                    $scope.ngModel = Number(originalValue).toFixed(2);
                }
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/form-components/bbaUnitInput.js